export const ApiQuerySpaceGroupPermissions = Symbol('ApiQuerySpaceGroupPermissions');
export const ApiUpdateSpaceGroupPermissions = Symbol('ApiUpdateSpaceGroupPermissions');
